export default __webpack_public_path__ + "static/media/demoSiteBack.fec8c680.svg";